import React, { useState } from 'react';
import { useSuperAuth } from '../../contexts/SuperAuthContext';

// Visually distinct from the firm login on purpose (dark, "Platform" wordmark).
// An operator who can suspend every firm on the system should never be in doubt
// about which console they are typing into.
const SuperLogin: React.FC = () => {
  const { login } = useSuperAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      await login(email.trim(), password);
    } catch (err: any) {
      setError(err?.response?.data?.message || 'Sign in failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-8">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-slate-800 rounded-2xl mb-4">
            <span className="text-white text-xl font-bold">◆</span>
          </div>
          <h1 className="text-2xl font-bold text-gray-900">Platform Console</h1>
          <p className="text-gray-500 text-sm mt-1">Operator sign-in</p>
        </div>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="label">Email Address</label>
            <input
              type="email"
              className="input-field"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="username"
              required
            />
          </div>
          <div>
            <label className="label">Password</label>
            <input
              type="password"
              className="input-field"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          </div>

          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 text-sm rounded-lg px-3 py-2">{error}</div>
          )}

          <button type="submit" className="btn-primary w-full !bg-slate-800 hover:!bg-slate-700" disabled={busy}>
            {busy ? 'Signing in…' : 'Sign In'}
          </button>
        </form>

        <p className="text-xs text-gray-400 text-center mt-6">
          This console manages firms and subscriptions. It does not give access to any firm's client data.
        </p>
      </div>
    </div>
  );
};

export default SuperLogin;
